import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold tracking-wide transition-all duration-300 rounded-full overflow-hidden group';
  const variants = {
    primary: 'bg-brand-green text-black hover:bg-[#33ff9f] shadow-[0_0_20px_rgba(0,255,136,0.3)] hover:shadow-[0_0_30px_rgba(0,255,136,0.5)]',
    secondary: 'bg-white text-black hover:bg-gray-200',
    outline: 'bg-transparent border border-brand-green text-brand-green hover:bg-brand-greenGlow'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl uppercase tracking-wider'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-193">
      <span className="relative z-10 flex items-center gap-2" data-id="element-194">{children}</span>
      {variant === 'primary' && <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-195" />}
    </motion.button>;
}